import { type Observable as ObservableType, Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { query$ } from '@atlassian/jira-software-swag/src/services/query/index.tsx';
import type { CardGql } from '../../model/graphql/index.tsx';

const cardDataOperationName = 'BacklogCardQuery';

export const getQuery = () => `
    query ${cardDataOperationName} ($boardId: ID!, $cardId: ID!) {
        boardScope(boardId: $boardId) {
            cards(cardIds: [$cardId]) {
                id
                issue {
                    id
                    key
                    summary
                    labels
                    type {
                        id
                        name
                        iconUrl
                    }
                    status {
                        id
                        name
                        category
                    }
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                }
                flagged
                done
                parentId
                fixVersions
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                childIssuesMetadata {
                    complete
                    total
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }
    }
`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, boardId: string, cardId: number): ObservableType<CardGql> =>
	query$(baseUrl, cardDataOperationName, getQuery(), { boardId, cardId }).flatMap((data) =>
		// @ts-expect-error - TS2571 - Object is of type 'unknown'.
		Observable.of(data.boardScope.cards[0]),
	);
